import { Navigate } from 'react-router-dom'

import isUserSignedInLoader from '../../loaders/isUserSignedInLoader'

import CompanyPage from './CompanyPage'
import EmailPage from './EmailPage'
import PasswordPage from './PasswordPage'
import PreparingPage from './PreparingPage'

const signUpRoutes = [
  {
    index: true,
    element: <Navigate to="password" replace />,
  },
  {
    element: <EmailPage />,
    path: 'email',
  },
  {
    element: <PreparingPage />,
    path: 'preparing',
  },
  {
    element: <PasswordPage />,
    loader: isUserSignedInLoader,
    path: 'password',
  },
  {
    element: <CompanyPage />,
    path: 'company',
  },
]

export default signUpRoutes
